import React from 'react';
import IntroTerms from 'on_web/components/onboarding/intro/IntroTerms';
import { useTranslation } from 'react-i18next';
import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';

export default function TermsOfService(props) {
  const { t } = useTranslation();
  return (
    <AssessmentPage
      headerMenuText={t('common.menu.mainItems.termsOfService')}
      bottomMenuSelectedOptionCode={'terms-of-service'}
      desktopMenuIndex={12}
      secondaryHeaderWithBackNavigation={true}
    >
      <IntroTerms noBottomNavigation />
    </AssessmentPage>
  );
}
